<template>
  <div>
    <HeaderBasic>
      <h2 class="page-title">Manage Property</h2>
      <router-link to="/" :exact="true">Home</router-link>
      <span> / </span>
      <span class="current">Manage Property</span>
    </HeaderBasic>
    <Property baseUrl="/Property/"></Property>
  </div>
</template>
<script>
export default {
  components: {
    HeaderBasic: () => import("./HeaderBasic"),
    Property: () => import("./Property")
  }
};
</script>
